import React, { Component } from "react";
import {
  vendasPorEmpresa,
  runVerificaAutenticacao,
  ListaTelasCRM,
} from "../../../services/api";
import GridTable from "../../../lib/GridTable";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import Header from "../../../components/Header";
import { ButtonSelect, ContentFilter, ContentFilterSelect, TablesGrid, TablesHighlights, TablesHighlightsItem, TablesHighlightsItemName, VendasEmpresaContainer, VendasEmpresaContainerText } from "./styles";

class VendasPorEmpresa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataStart: "",
      dataEnd: "",
      dados: [],
      dadosTotal: [],

      codigo_usuario: JSON.parse(localStorage.getItem("authentication"))
        .codigo_usuario,
      codigo_vendedor: JSON.parse(localStorage.getItem("authentication"))
        .codigo_vendedor,

      control_inclusao: null,
      control_alteracao: null,
      control_exclusao: null,
      control_consulta: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(event) {
    event.preventDefault();

    const { dataStart, dataEnd } = this.state;

    this.getLessons(dataStart, dataEnd);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  componentDidMount() {
    runVerificaAutenticacao();
    this.CarregaPermissoes();
  }

  CarregaPermissoes = async () => {
    try {
      const response = await ListaTelasCRM.get(
        "/" + window.location.pathname.replace("/", "")
      );
      var data = response.data;

      var codigo_tela = null;
      for (var obj in data) {
        codigo_tela = obj;
      }

      this.setState({
        codigo_tela: codigo_tela,
        control_inclusao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].inclusao,
        control_alteracao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].alteracao,
        control_exclusao: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].exclusao,
        control_consulta: JSON.parse(localStorage.getItem("authentication"))
          .permissoes_usuario[codigo_tela].consulta,
      });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getLessons = async (dateStart, endDate) => {
    if (this.state.control_consulta != "S") {
      alert("Permissão negada");
      return false;
    }

    const startDate = dateStart;
    const dataFinal = endDate;

    try {
      const response = await vendasPorEmpresa.post("", {
        data_inicio: startDate,
        data_fim: dataFinal,
      });

      const dados = response.data.splice(0, response.data.length - 1);
      const dadosTotal = response.data.splice(-1, 1);

      this.setState({ dados: dados, dadosTotal: dadosTotal });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  render() {
    const { dados, dadosTotal } = this.state;

    function priceFormatter(value) {
      var atual = value
        ? parseFloat(value).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        : "";
      return atual;
    }

    function integerFormatter(value) {
      var atual = value
        ? parseFloat(value).toLocaleString("pt-BR", {
            minimumIntegerDigits: 2,
            minimumFractionDigits: 0,
          })
        : "";
      return atual;
    }

    const columns = [
      {
        dataField: "nome_cliente",
        text: "Cliente",
      },
      {
        dataField: "data",
        text: "Data",
      },
      {
        dataField: "quantidade_propostas",
        text: "Propostas",
        formatter: integerFormatter,
        sort: true,
      },
      {
        dataField: "quantidade_pedidos",
        text: "Pedidos",
        formatter: integerFormatter,
        sort: true,
      },
      {
        dataField: "valor_total_pedidos",
        text: "Valor",
        formatter: priceFormatter,
        sort: true,
      },
      {
        dataField: "percentual_total_vendas",
        text: "Porcentual de venda",
        sort: true,
      },
      {
        dataField: "valor_medio_pedido",
        text: "Ticket Médio",
        formatter: priceFormatter,
        sort: true,
      },
      {
        dataField: "",
        text: "Detalhes",
        element: (
          <a href={``}>
            <span className="icon icon-20 icon-folder-pink"></span>
          </a>
        ),
      },
    ];

    return (
      <>
          <VendasEmpresaContainer>
            <VendasEmpresaContainerText>
                <h1>
                  VENDAS POR <strong>EMPRESA</strong>
                </h1>
            </VendasEmpresaContainerText>
          </VendasEmpresaContainer>
        <form onSubmit={this.handleSubmit}>
          <ContentFilter>
            <ContentFilterSelect>
              <label>
                Data Início:{" "}
              </label>
              <input
                name="dataStart"
                type="date"
                value={this.state.dataStart}
                onChange={this.handleChange}
              />
            </ContentFilterSelect>
            <ContentFilterSelect>
              <label>
                Data Final:{" "}
              </label>
              <input
                name="dataEnd"
                type="date"
                value={this.state.dataEnd}
                onChange={this.handleChange}
              />
            </ContentFilterSelect>
            <ButtonSelect>
              Aplicar
            </ButtonSelect>
          </ContentFilter>
          <TablesGrid >
            <TablesHighlights>
              {dadosTotal.map((dado) => (
                <>
                  <TablesHighlightsItem>
                    <TablesHighlightsItemName>
                      PROPOSTAS <strong>{dado.quantidade_propostas}</strong>
                    </TablesHighlightsItemName>
                  </TablesHighlightsItem>

                  <TablesHighlightsItem>
                    <TablesHighlightsItemName>
                      PEDIDOS <strong>{dado.quantidade_pedidos}</strong>
                    </TablesHighlightsItemName>
                  </TablesHighlightsItem>

                  <TablesHighlightsItem>
                    <TablesHighlightsItemName>
                      VALOR PEDIDOS{" "}
                      <strong>
                        {parseFloat(dado.valor_total_pedidos).toLocaleString(
                          "pt-BR",
                          { style: "currency", currency: "BRL" }
                        )}
                      </strong>
                    </TablesHighlightsItemName>
                  </TablesHighlightsItem>
                </>
              ))}
            </TablesHighlights>

            {dados.length > 0 ? (
              <GridTable columns={columns} dados={this.state.dados} />
            ) : (
              <></>
            )}

            {/* <BootstrapTable bootstrap4 classes="innovation-crm-vendas-empresa-container__content__tabless__table" keyField='id' data={dados} columns={columns} /> */}
          </TablesGrid>
        </form>
      </>
    );
  }
}

export default VendasPorEmpresa;
